var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c(
      "div",
      [
        _c("team-member-invoices-overview-toolbar", {
          class: _vm.$root.isTablet ? "tablet-filter-container" : "",
          attrs: {
            "team-members": function () {
              return this$1.teamMembers
            },
            "team-region-id": _vm.filters.teamRegionId,
            "batch-filter-list": _vm.batchFilterList,
            "disable-export": _vm.shouldDisableExport,
          },
          on: {
            onFilterInvoices: _vm.handleFilterOrSearch,
            onExportClicked: _vm.handleExportClick,
            onSendToAccountingPackageClicked: _vm.processInvoicesBasedOnFilter,
            onCreateInvoice: _vm.handleGenerateInvoice,
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
      },
      [
        _c(
          "md-card",
          { staticClass: "custom-card" },
          [
            _c(
              "tabs",
              {
                staticClass: "custom-tab-list",
                attrs: {
                  "tab-name": _vm.tabNames,
                  "color-button": "success",
                  "selected-panel":
                    _vm.replaceDashToSpacesAndCapitalizeFirstLetter(
                      _vm.activeTab
                    ),
                },
                on: { "switch-panel": _vm.switchTab },
              },
              [
                _vm._l(_vm.tabNames, function (tabName, index) {
                  return _c("template", { slot: "tab-pane-" + (index + 1) }, [
                    _c(
                      "div",
                      {
                        key: tabName,
                        staticClass: "pull-right invoice-contents",
                      },
                      [
                        _c(_vm.tabComponents[index], {
                          ref: "tabComponent",
                          refInFor: true,
                          tag: "component",
                          staticClass: "invoice-contents",
                          attrs: { filters: _vm.filters },
                          on: {
                            batchFilterUpdated: _vm.handleBatchFilterUpdated,
                            selectionChanged: _vm.handleSelectionChanged,
                            listChanged: _vm.handleListChanged,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                }),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm.showProgressBox
      ? _c("div", { staticClass: "progress-container" }, [
          _c(
            "div",
            { staticClass: "button-close" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-default md-just-icon md-round",
                  on: { click: _vm.handleCloseProgressBox },
                },
                [_c("md-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          !_vm.isProgressComplete
            ? _c("div", { staticClass: "progress-text-section" }, [
                _vm._m(0),
                _vm.totalInvoice == 0
                  ? _c("div", [_vm._v("Preparing invoices...")])
                  : _c("div", [
                      _vm._v(
                        _vm._s(_vm.currentProcessedInvoice) +
                          " of " +
                          _vm._s(_vm.totalInvoice) +
                          " invoices have been generated."
                      ),
                    ]),
              ])
            : _c("div", { staticClass: "progress-text-section" }, [
                _c(
                  "div",
                  [
                    _c("md-icon", { staticClass: "green-check" }, [
                      _vm._v("check_circle"),
                    ]),
                  ],
                  1
                ),
                _c("div", [
                  _vm._v(
                    "\n                Process has been completed.\n            "
                  ),
                ]),
              ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("div", { staticClass: "btn-loader route-loader" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }